import { BorderlessDropdown, Field } from '@klarna/bubble-ui';
import { generateCyElemId } from 'moet-test-utils/cypress/utils';
import { CY_ADDRESS_FORM_COMPONENT_IDS, tPrefix } from '../constants';

const { INPUT_REGION } = CY_ADDRESS_FORM_COMPONENT_IDS;

export const regionField = (t, defaultField = {}, country, usStates, { isMobile = false }) => ({
  ...defaultField,
  component: country === 'US' ? BorderlessDropdown : Field,
  size: isMobile ? 1 : 0.5,
  label: t(`${tPrefix}.${country === 'US' ? 'state' : 'region'}.label`),
  isOptional: country !== 'US',
  extraProps: {
    ...defaultField.extraProps,
    ...generateCyElemId(INPUT_REGION, window),
    ...(country === 'US' ? { options: usStates } : {}),
    isUnderlined: true,
  },
});
